import { render, staticRenderFns } from "./DefineImpacts.vue?vue&type=template&id=381f3495&scoped=true"
import script from "./DefineImpacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefineImpacts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DefineImpacts.vue?vue&type=style&index=0&id=381f3495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f3495",
  null
  
)

/* custom blocks */
import block0 from "./DefineImpacts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionTitle.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default,IxCardImpact: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/Impact.vue').default})
